import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useApi } from '../hooks/useApi';
export default function Dispatch() {
  const { dispatchId } = useParams();
  const navigate = useNavigate();
  const { fetchApi,loading,error } = useApi();
  const [order,setOrder] = useState<{ order_number: string; customer_name: string; status: string } | null>(null);
  const [tracking,setTracking] = useState('');
  useEffect(() => { void fetchApi<{ order: typeof order }>(`/orders/${dispatchId}`).then(r => { if (r) setOrder(r.order); }); },[dispatchId]);
  return <div className="page"><div className="page-header"><button onClick={() => navigate('/dispatches')}>Back</button><h1>Dispatch order</h1></div><div className="page-content">
    {error && <p role="alert">{error}</p>}
    {order && <><h2>{order.order_number}</h2><p>{order.customer_name}</p><p>Status: {order.status}</p>
      <label>Tracking number<input className="form-input" value={tracking} onChange={e => setTracking(e.target.value)} /></label>
      <button className="btn btn-primary" disabled={loading} onClick={async () => {
        const result = await fetchApi<{ success: boolean }>('/picking/dispatch',{ method:'POST',body:JSON.stringify({ order_id:Number(dispatchId),tracking_number:tracking }) });
        if (result?.success) navigate(`/signature/${dispatchId}`);
      }}>Dispatch and record signature</button></>}
  </div></div>;
}
